<div class="kgr-code-input">
  @for (digit of digits; track $index) {
    <input
      #digitInput
      type="text"
      [attr.inputmode]="alphanumeric ? 'text' : 'numeric'"
      autocomplete="one-time-code"
      maxlength="1"
      class="kgr-input kgr-code-input__field"
      [value]="digit"
      [disabled]="isDisabled"
      (focus)="onFocus($event)"
      (input)="onInput($event, $index)"
      (keydown)="onKeyDown($event, $index)"
      (paste)="onPaste($event)"
      (blur)="onTouched()"
    />
  }
</div>
